import React from 'react';
import { useSelector } from 'react-redux';
import { FLOWS_ENUM } from '../../common/enums';
import { updatePermitData } from '../../store/slices/adminUpdate/adminUpdateSlice';
import { useAppDispatch } from 'src/store/store';
import { selectAdminUpdatedPermitData } from 'src/store/slices/adminUpdate/adminUpdateSelectors';
import { ApplicationData } from 'src/types/flow';
import { ContactsPage } from 'src/components/pages/ContactsPage';

const AdminUpdateContacts = () => {
  const dispatch = useAppDispatch();
  const data = useSelector(selectAdminUpdatedPermitData) as ApplicationData;

  const updateApplicationData = (data: ApplicationData) => {
    dispatch(updatePermitData(data));
  };

  return (
    <ContactsPage
      data={data}
      flow={FLOWS_ENUM.ADMIN_UPDATE}
      updateApplicationData={updateApplicationData}
    />
  );
};

export default AdminUpdateContacts;
